import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  DeleteButton,
  TopToolbar,
  CreateButton,
  FunctionField,
  useTranslate,
  useNotify,
  useRefresh,
  useDataProvider,
} from 'react-admin'
import {
  CalculatorIcon,
  ArrowDownTrayIcon,
  ArrowPathIcon,
} from '@heroicons/react/24/outline'
import { Chip, IconButton, Tooltip } from '@mui/material'

const MLTaskStatusChip = ({ record }) => {
  if (!record) return null

  const colors = {
    uploaded: 'default',
    processing: 'primary',
    completed: 'success',
    failed: 'error',
  }

  return (
    <Chip
      label={record.status.toUpperCase()}
      color={colors[record.status] || 'default'}
      size="small"
      variant="outlined"
    />
  )
}

const DownloadButton = ({ record }) => {
  if (!record || record.status !== 'completed' || !record.predictions_s3_key)
    return null

  const handleDownload = (e) => {
    e.stopPropagation()
    // In a real app, this would be a signed S3 URL or an API proxy
    // For now, we'll assume there's an endpoint to get the file
    window.open(`/api/v1/ml-tasks/${record.id}/download`, '_blank')
  }

  return (
    <Tooltip title="Download Predictions CSV">
      <IconButton onClick={handleDownload} size="small" color="primary">
        <ArrowDownTrayIcon className="h-5 w-5" />
      </IconButton>
    </Tooltip>
  )
}

const MLTaskListActions = () => (
  <TopToolbar>
    <CreateButton
      label="Run Predictions"
      variant="contained"
      sx={{ marginRight: 2 }}
    />
  </TopToolbar>
)

export const MLTaskList = () => {
  const translate = useTranslate()

  return (
    <List
      actions={<MLTaskListActions />}
      sort={{ field: 'created_at', order: 'DESC' }}
      resource="ml-tasks"
      title="Machine Learning Predictions"
    >
      <Datagrid
        sx={{
          '& .MuiTableCell-head': {
            fontWeight: 'bold',
            backgroundColor: '#f9f8f7',
          },
        }}
      >
        <TextField source="id" />
        <TextField source="filename" label="Source Spreadsheet" />
        <TextField source="model_name" label="Model" />
        <TextField source="ml_provider" label="Provider" />
        <FunctionField
          label="Status"
          render={(record) => <MLTaskStatusChip record={record} />}
        />
        <DateField source="created_at" label="Requested" showTime />
        <DateField source="completed_at" label="Finished" showTime />
        <FunctionField
          label="Actions"
          render={(record) => (
            <div className="flex items-center space-x-2">
              <DownloadButton record={record} />
              <DeleteButton />
            </div>
          )}
        />
      </Datagrid>
    </List>
  )
}

export const MLIcon = CalculatorIcon
